export const getPreviousBookingEndpoint = '/berths/booking/previous' as const
